import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './HeaderPlaceName.css';
import withStyles from '../../decorators/withStyles';
import { capitalize, isEcuador, xlt } from "../../utils/utils";


class PlaceName extends Component {

  static propTypes = {
    placeName: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
    placeType: PropTypes.string.isRequired,
    // placeNameVisible: PropTypes.bool.isRequired,
    error: PropTypes.object
  };

  // Quick hack to format names for Ecuador
  getParishName(countryName) {
    const { placeName } = this.props;
    const nameElems = placeName.split(',');
    return (
      <span>
        <span>{nameElems[0]}</span>
        <span>, </span>
        <span>{nameElems[2]}</span>
        <span>, </span>
        <span>{countryName}</span>
      </span>
    );
  }

  formatMultipartName() {
    const { placeID, placeName, placeType } = this.props; 
    const nameElems = placeName.split(',');

    if (isEcuador(placeID) && placeType === 'parish') {
      return this.getParishName('Ecuador');
    } else {
      return (
        <span>
          {nameElems.slice(0, nameElems.length - 1).map((elem, index) => (          
            <span key={`placeName-${elem}-${index}`}>
              <span>{xlt(elem.replace(/^\s+|\s+$/g, ''))}</span>
              <span>, </span>
            </span>
          ))}
          <span>{nameElems[nameElems.length - 1].replace(/ /, '')}</span>
        </span>
      );
    }
  }

  getPlaceName() {
    const { placeName } = this.props;
    const nameElems = placeName.split(',');
    if (nameElems.length > 1) {
      return this.formatMultipartName();
    } else {
      return <span>{xlt(placeName)}</span>;
    }
  }

  render() {
    const formattedName = this.getPlaceName();
    return (
      <section className="HeaderPlaceName">
        <h1 className="banner">{formattedName}</h1>
      </section>
    )
  }
}

export default withStyles(styles)(PlaceName);
